import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-generic-ng-table',
  templateUrl: './generic-ng-table.component.html',
  styleUrls: ['./generic-ng-table.component.scss'],
})
export class GenericNgTableComponent implements OnInit {
  @Input() tableData = [];
  @Input() tableCols = [];
  @Input() scrollHeight = '';
  constructor() {}

  ngOnInit(): void {}
}
